import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appDetailsHistoriePanel]',
})
export class DetailsHistoriePanelDirective {
  readonly id = input.required<string>({ alias: 'appDetailsHistoriePanel' });
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
